export default {"src":"/login-app/[GIT_HASH]/_next/static/media/curly_braces.41b49fa5.svg","height":12,"width":14,"blurWidth":0,"blurHeight":0};